import { useState } from 'react';
import { testPDFWorker } from '../utils/testAutoGrading';

export default function PDFTest() {
  const [testResult, setTestResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const runPDFTest = async () => {
    setLoading(true);
    try {
      const result = await testPDFWorker();
      setTestResult(result);
    } catch (error) {
      setTestResult({ success: false, error: error.message });
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-100 py-8">
      <div className="container mx-auto px-4">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-6">🔧 PDF.js Worker Test</h1>

          <div className="mb-6">
            <button
              onClick={runPDFTest}
              disabled={loading}
              className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 disabled:opacity-50"
            >
              {loading ? 'Testing...' : 'Test PDF.js Worker'}
            </button>
          </div>

          {testResult && (
            <div className={`p-4 rounded-lg ${testResult.success ? 'bg-green-50 border border-green-200' : 'bg-red-50 border border-red-200'}`}>
              <h2 className="text-xl font-semibold mb-4">
                {testResult.success ? '✅ Test Results' : '❌ Test Failed'}
              </h2>

              {testResult.success ? (
                <div>
                  <p className="text-green-700">PDF.js worker loaded successfully!</p>
                  <p className="text-sm text-gray-600 mt-2">
                    <strong>Worker Source:</strong> {testResult.workerSrc}
                  </p>
                </div>
              ) : (
                <div>
                  <p className="text-red-700">PDF.js worker failed to load</p>
                  <p className="text-sm text-red-600 mt-2">
                    <strong>Error:</strong> {testResult.error}
                  </p>
                </div>
              )}
            </div>
          )}

          <div className="mt-8 bg-gray-50 p-4 rounded-lg">
            <h3 className="font-semibold text-gray-700 mb-2">About This Test</h3>
            <p className="text-sm text-gray-600">
              This test verifies that PDF.js worker is properly configured in the Vite environment.
              It checks if the worker can load and process a minimal PDF document.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}